<template>
  <div v-if="modelValue" class="modal-overlay">
    <div class="modal-card">
      <h3>{{ header }}</h3>

      <input
        ref="inputRef"
        v-model.number="valor"
        type="number"
        class="input-numero"
        @keyup.enter="confirmar"
        @keyup.esc="cancelar"
      />

      <div class="modal-actions">
        <button @click="cancelar">Cancelar</button>
        <button @click="confirmar">Confirmar</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, nextTick } from 'vue';

const props = defineProps({
  modelValue: Boolean,
  header: {
    type: String,
    default: 'Informe o valor',
  },
  valorInicial: {
    type: Number,
    default: null,
  },
});

const emit = defineEmits(['update:modelValue', 'confirmar', 'cancelar']);

const valor = ref(null);
const inputRef = ref(null);

watch(
  () => props.modelValue,
  async (aberto) => {
    if (aberto) {
      valor.value = props.valorInicial;
      await nextTick();
      inputRef.value?.focus();
    }
  }
);

function confirmar() {
  if (valor.value === null || valor.value === '') return;

  emit('confirmar', Number(valor.value));
  emit('update:modelValue', false);
}

function cancelar() {
  emit('cancelar');
  emit('update:modelValue', false);
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-card {
  background: #fff;
  padding: 18px;
  border-radius: 8px;
  width: 320px;
}

.input-numero {
  width: 100%;
  padding: 8px;
  margin-top: 12px;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}
</style>